import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import DialOutRequestAction from "common/meeting/tech_controls/audio/dial_out/request";
import DialOutHangUpAction from "common/meeting/tech_controls/audio/dial_out/hang_up";
import PhoneControl from "common/meeting/tech_controls/audio/phone";
import { CALL_STATES, mapCallStatusToCallState } from "constants/dial_out";
import { useCompanyName } from "util/feature_detection";

import { AVItem } from "./container";

function phoneAudioConfig({ activeCall }) {
  const activeCallId = activeCall?.id;
  const callStatus = activeCall?.callStatus;
  const callState = mapCallStatusToCallState(callStatus);
  const connected = callState === CALL_STATES.CONNECTED || callState === CALL_STATES.CONNECTING;
  return { activeCallId, callStatus, callState, connected };
}

function PhoneItem({ onChangeDevices, onHangUp, selectedDevices, meetingParticipant }) {
  const companyName = useCompanyName();
  const { connected, activeCallId, callState } = phoneAudioConfig(meetingParticipant);
  const handleDial = (requestMeetingDialOut) => {
    requestMeetingDialOut(selectedDevices.phone);
  };
  const handleHangUp = (hangUpMeetingDialOut) => {
    if (connected) {
      hangUpMeetingDialOut(activeCallId);
    }
    onHangUp();
  };

  return (
    <AVItem
      selectNode={
        <DialOutRequestAction meetingParticipant={meetingParticipant}>
          {(requestMeetingDialOut) => (
            <DialOutHangUpAction>
              {(hangUpMeetingDialOut) => (
                <>
                  <div className="AudioVideoContainer--Section">
                    <FormattedMessage
                      id="1cfde279-4afb-4cf4-a54a-e630489faba1"
                      defaultMessage="{companyName} will call your phone and connect your audio to this meeting"
                      values={{ companyName }}
                    />
                  </div>
                  <PhoneControl
                    phoneNumber={selectedDevices.phone}
                    onPhoneNumberChange={(phone) => onChangeDevices({ phone })}
                    callState={callState}
                    onDial={() => handleDial(requestMeetingDialOut)}
                    onHangUp={() => handleHangUp(hangUpMeetingDialOut)}
                    label={
                      <FormattedMessage
                        id="288aae9d-525f-4ed1-b755-3632c446d92e"
                        defaultMessage="Enter phone number"
                      />
                    }
                    showNotaryConnectionWarn={false}
                  />
                </>
              )}
            </DialOutHangUpAction>
          )}
        </DialOutRequestAction>
      }
      isSubitem
    />
  );
}

PhoneItem.propTypes = {
  onChangeDevices: PropTypes.func.isRequired,
  onHangUp: PropTypes.func.isRequired,
  selectedDevices: PropTypes.shape({
    phone: PropTypes.string,
  }).isRequired,
  meetingParticipant: PropTypes.shape({
    id: PropTypes.string.isRequired,
    activeCall: PropTypes.shape({
      id: PropTypes.string.isRequired,
      callStatus: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default PhoneItem;
